module.exports = __webpack_public_path__ + "static/media/mamoru.b6466215.gif";